export default __webpack_public_path__ + "static/media/landChest3.d29c8ef0.svg";